import { render, staticRenderFns } from "./ModalDetailArea.vue?vue&type=template&id=2451aedd"
import script from "./ModalDetailArea.vue?vue&type=script&lang=js"
export * from "./ModalDetailArea.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailArea.vue?vue&type=style&index=0&id=2451aedd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports